import { useMemo } from 'react'
import { getInitialSearchParams } from 'src/Hooks/getInitialSearchParams'

/*
 * This hook derives the initial search values.
 */
export const useInitialSearchParams = () => {
  return useMemo(() => getInitialSearchParams(), [])
}
